<template>
  <tooltip placement="top" :options="{ hideOnClick: true }">
    <template #trigger>
      <div>
        {{ minutesLabel }}
      </div>
    </template>
    <template #tooltip>
      <div>{{ tooltipContent }}</div>
    </template>
  </tooltip>
</template>

<script>
import { isFalsy } from "@/lib/helpers.js";

import Tooltip from "@/components/Tooltip.vue";
import { formatDuration } from "@/mixins";

export default {
  components: {
    Tooltip
  },
  props: {
    minutes: {
      type: Number,
      default: null
    },
    defaultText: {
      type: String,
      default: "No Data"
    },
    notAvailable: {
      type: Boolean,
      default: false
    },
    notAvailableText: {
      type: String,
      default: "Not Available"
    }
  },
  computed: {
    minutesLabel() {
      if (this.notAvailable) {
        return "N/A";
      }
      if (isFalsy(this.minutes)) {
        return "--";
      }
      return formatDuration(this.minutes);
    },
    tooltipContent() {
      if (this.notAvailable) {
        return this.notAvailableText;
      }
      if (isFalsy(this.minutes)) {
        return this.defaultText;
      }
      return `${(this.minutes || 0).toLocaleString()} minutes`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
